module.exports = __webpack_public_path__ + "static/media/noRecordFound.cfb0685e.png";